/** Classic Attendant with 4 HighVoltage relays */
const platformCapabilitiesClassic = {
    Controllers: [ {
        ControllerUUID: "dummy-classic4-uuid-1234",
        Modules: [ {
            PortTypes: {
                Bus: [ {
                    PortNumber: 1
                }, {
                    PortNumber: 2
                }, {
                    PortNumber: 3
                }, {
                    PortNumber: 4
                } ],
                HighVoltage: [ {
                    PortNumber: 1
                }, {
                    PortNumber: 2
                }, {
                    PortNumber: 3
                }, {
                    PortNumber: 4
                } ],
                LightDriverLowVoltage: [],
                LowVoltage: [ {
                    PortNumber: 1
                }, {
                    PortNumber: 2
                }, {
                    PortNumber: 3
                }, {
                    PortNumber: 4
                }, {
                    PortNumber: 5
                } ],
                Actuator: [ {
                    PortNumber: 1
                }, {
                    PortNumber: 2
                }, {
                    PortNumber: 3
                }, {
                    PortNumber: 4
                }, {
                    PortNumber: 5
                } ],
                Thermistor: [ {
                    PortNumber: 1
                }, {
                    PortNumber: 2
                }, {
                    PortNumber: 3
                }, {
                    PortNumber: 4
                }, {
                    PortNumber: 5
                } ],
                FlowSwitch: [ {
                    PortNumber: 1
                }, {
                    PortNumber: 2
                }, {
                    PortNumber: 3
                }, {
                    PortNumber: 4
                }, {
                    PortNumber: 5
                } ],
                ChemistryPH: [ {
                    PortNumber: 1
                } ],
                ChemistryORP: [ {
                    PortNumber: 1
                } ],
                Ma: [ {
                    PortNumber: 1
                }, {
                    PortNumber: 2
                } ],
                InterfaceButtons: []
            },
            Type: "POOLSIDE",
            ModulePortInformation: null,
            ModuleData: {
                ModuleNumber: 1,
                McuVersion: "022",
                BoardRevision: 4,
                Serial: ""
            },
            Attached: true,
            UniqueBusIdentifier: null,
            ModuleNumber: "1"
        } ]
    } ]
};

export default platformCapabilitiesClassic;